module.exports = __webpack_public_path__ + "img/midia-r7-1024x1024.b83d3f92.png";